export var getBitValueFromBool = function getBitValueFromBool(value) {
  return Number(value).toString();
};
export var getBoolFromBitValue = function getBoolFromBitValue(bitValue) {
  if (bitValue) {
    return !!Number(bitValue);
  }
};